
import { extractMessageFromException } from '@/utils/helpers'
import analytics from '@/mixins.js/analytics'

export default {
  mixins: [analytics],
  transition: 'page',
  head () {
    return {
      title: 'Design Services',
      bodyAttrs: {
        class: 'page-contact page-default page-design'
      }
    }
  },
  methods: {
    setSubject (subject) {
      document.getElementById('services-form').scrollIntoView();
      this.contact.subject = subject;
    },
    async onSubmit () {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        this.isLoading = true;
        try {
          this.trackEvent('Contact', 'Send message')
          await this.$backend.contact.post(
            this.contact
          )
          this.sent = true
        } catch (error) {
          this.$toast.error(extractMessageFromException(error))
        } finally {
          this.isLoading = false
        }
      }
    }
  },
  data () {
    return {
      contact: {
        subject: undefined
      },
      isLoading: false,
      invalid: true,
      sent: false,
      subjects: [
        {
          value: 'matching-slides',
          label: 'Matching slides with branding'
        },
        {
          value: 'graphical-update',
          label: 'Graphical upgrade of slides'
        },
        {
          value: 'pp-templates',
          label: 'PowerPoint templates'
        },
        {
          value: 'pp-slides',
          label: 'PowerPoint slides'
        },
        {
          value: 'vector-graphics',
          label: 'Vector graphics'
        },
        {
          value: 'pp-slides-design',
          label: 'PowerPoint slides design'
        },
        {
          value: 'pp-data-visualization',
          label: 'PowerPoint data visualization'
        },
        {
          value: 'pp-1on1',
          label: 'PowerPoint 1 on 1'
        },
        {
          value: 'other',
          label: 'Other'
        }
      ]
    }
  }
}
